import { Component } from 'preact'
import Row from './Row'
import Sorting from './Sorting'
import classNames from 'classnames'

class Table extends Component {
  render (props, state) {
    const { model, rows, rowId, sort, onSortChange, narrow } = props
    const useObjectModel = model[0].hasOwnProperty('header')

    return (
      <table className={classNames('control-table', { 'narrow': narrow })}>
        <thead>
          <tr>
            {
              Object.keys(model).map((key) => {
                return (<th>
                  {!model[key].hasOwnProperty('sorting') &&
                    <div class={`table-header-cell-${model[key].accessor}`}>
                      {useObjectModel ? model[key].header : model[key]}
                    </div>}
                  {model[key].hasOwnProperty('sorting') &&
                    <div class={`table-header-cell-${model[key].accessor}`} onClick={() => {
                      onSortChange(model[key].sorting)
                    }}>
                      {useObjectModel ? model[key].header : model[key]}
                      <Sorting
                        direction={sort.direction}
                        isEnabled={sort.order === model[key].sorting}
                      />
                    </div>}
                </th>)
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            Object.keys(rows).map((key) => {
              return (<Row id={rowId} cells={rows[key]} model={useObjectModel ? model : null} />)
            })
          }
        </tbody>
      </table>
    )
  }
}

export default Table
